import { defineComponent, onMounted, ref } from 'vue';
import HeaderCom from '@/components/HeaderCom.vue';
import FooterCom from '@/components/footerCom.vue';
import ApplyCom from '@/components/applyCom.vue';
import ModuleHeadCom from '@/components/moduleHeadCom.vue';
import bg from '@/assets/img/banner/consultingService-banner.png';
import RecommendCom from './components/recommendCom.vue';
import ServiceIntr from './components/serviceIntr.vue';
import AdvantageCom from './components/advantageCom.vue';
import ProcessCom from './components/processCom.vue';
import ServiceContent from './components/serviceContent.vue';
import { wachtPageAni } from '@/uitl/currencyFunc.js';
export default defineComponent({
  components: {
    HeaderCom,
    FooterCom,
    ApplyCom,
    ModuleHeadCom,
    RecommendCom,
    ServiceIntr,
    AdvantageCom,
    ProcessCom,
    ServiceContent
  },
  setup() {
    const ServiceContent = ref(null);
    const AdvantageCom = ref(null);
    const ProcessCom = ref(null);
    const RecommendCom = ref(null);
    const ApplyCom = ref(null);
    onMounted(() => {
      wachtPageAni([ServiceContent, AdvantageCom, ProcessCom, RecommendCom, ApplyCom]);
    });
    return {
      ServiceContent,
      AdvantageCom,
      ProcessCom,
      RecommendCom,
      ApplyCom,
      BG: bg
    };
  }
});